const snackbarConstantsAr = {
  snackbarErrorMsg: 'حدث خطأ ما',
  snackbarSuccessMsg: 'تم الحفظ بنجاح',
  snackbarSuccessDeletedMsg: 'تم الحذف بنجاح',
  snackbarResendCodeSuccessMsg: 'تم اعادة ارسال رمز التحقق بنجاح',
  noDataToExport: 'لا توجد بيانات للتصدير',
  DataExportSuccess: 'تم تصدير البيانات بنجاح',
  inventoryManagementErrorSnackBar: 'حدث خطأ أثناء تحميل البيانات، يرجى المحاولة مرة أخرى لاحقًا',
};

export default snackbarConstantsAr;